module.exports = __webpack_public_path__ + "static/media/Finance06.26f0ed66.png";